var _templateObject, _templateObject2;

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  strings.raw = raw;
  return strings;
}

import styled from "styled-components";
import { AccordionPanel } from "grommet";
export var StyledWrapper = styled.div(
  _templateObject || (_templateObject = _taggedTemplateLiteralLoose([""]))
);
export var StyledPanel = styled(AccordionPanel)(
  _templateObject2 ||
    (_templateObject2 = _taggedTemplateLiteralLoose([
      "\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n  border-radius: 1rem;\n  margin-bottom: 1rem;\n",
    ]))
);
